import { headers, search } from './attributes';
import {
  dataListMerchantCriteria,
  dataListMerchantType,
  dataListTaskType,
  dataListHistoryRmStatus,
} from '../../../store/params';
import { date, showAlert } from '../../../lib/helpers';

export default {
  data: () => ({
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    dialogDelete: false,
    headers,
    editedIndex: -1,
    search,
    selectedRow: '',
    listMerchantCriteria: dataListMerchantCriteria,
    listMerchantType: dataListMerchantType,
    listTaskType: dataListTaskType,
    dateFormatted: '',
    dateMenu: false,
    dateFormattedUpdated: '',
    dateMenuUpdated: false,
    listStatus: dataListHistoryRmStatus,
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.daftarTugas.rm.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.daftarTugas.rm.flashError;
      },
      set() {
        this.$store.commit('daftarTugas/rm/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.daftarTugas.rm.errors;
    },
    loading() {
      return this.$store.state.daftarTugas.rm.loading;
    },
    merchants() {
      return this.$store.state.daftarTugas.rm.allMerchantsHistory;
    },
    totalMerchants() {
      return this.$store.state.daftarTugas.rm.totalMerchantsHistory;
    },
    totalPage() {
      return this.$store.state.daftarTugas.rm.totalPage;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    'search.created_at': {
      handler() {
        this.dateFormatted = this.formatDate(this.search.created_at);
        this.getData();
      },
    },

    'search.updated_at': {
      handler() {
        this.dateFormattedUpdated = this.formatDate(this.search.updated_at);
        this.getData();
      },
    },

    show() {
      if (!this.show) {
        this.clearSearch();
      }
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.merchant_name = '';
      this.search.mid = '';
      this.search.merchant_type = '';
      this.search.task_type = '';
      this.search.status = '';
      this.search.address = '';
      this.search.reference_number = '';
      this.search.created_at = null;
      this.$nextTick(() => {
        this.getData();
      });
    },

    getData() {
      this.$store.commit('daftarTugas/rm/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('daftarTugas/rm/fetchMerchantsHistory', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    viewItem(item) {
      this.$router.push(`/daftar-tugas/inputer-history-list/view/${item.id}`);
    },

    revisiItem(item) {
      this.$router.push(`/daftar-tugas/inputer-list/edit/${item.id}`);
    },

    closeFlash() {
      this.$store.commit('daftarTugas/rm/setFlashErrorMessage', '');
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    exportExcel() {
      if (this.totalMerchants < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
      } else {
        const { page, itemsPerPage } = this.options;

        this.$store.dispatch('exportExcel', {
          date,
          page,
          itemsPerPage,
          sortBy: ['id'],
          sortDesc: [true],
          search: this.search,
          countData: this.totalMerchants,
          module: 'history-rm-to-do-list',
          exportUrl: 'export/generate-export-file/index',
          exportController: 'export/get-export-file',
          sourceData: 'sql',
        });
      }
    },
  },
};